<template>
 <div class="col-12">
 <div class="search-padd">
    <div v-if="subscriptionLevels.length == 1 && sub_loading == false" class="alert alert-danger" style="margin-top: 10px;">Pricing is not assigned to this Account. Please select pricing from Affiliate Tab.</div>

<!-- purchase block -->
   <div v-if="mode == 'doPurchase'">
    <div class="col-xs-12 col-12 col-md-12 override-padding unit-wrapper" id="normal-unit-table">

        <div class="crm_admin_heading purchase-heading-bar">
            <div class="row">
                <div class="col-3 col-md-3">Unit Type</div>
                <div class="col-2 col-md-2">Quantity</div>                    
                <div class="col-2 col-md-2 text-center">Price</div>
                <div class="col-2 col-md-2">Override Price</div>
                <div class="col-2 col-md-2 text-center">Sub Total</div>
                <div class="col-1 col-md-1 text-center">&nbsp;</div>
            </div>
        </div>
        <form id="license_form" autocomplete="off">
         <div v-for="(newLicense, index) in enterprise_new_licenses" :key="index" >
         
            <div v-bind:class="'account_details' + index" v-bind:id="'account_details_more' + index">
             <div class="row res_content"> 
                
                            
                <div class="col-3 col-md-3">
                <b-form-select class="custom-select billingInput"
                v-bind:id="'newLicense_unittype_' + index"
                v-bind:name="'newLicense_unittype[' + index + ']'"
                v-model="newLicense.subscriptionId" :options="subscriptionLevels"
                v-validate="'required'"                
                v-on:change="getPriceforSubscription(newLicense.subscriptionId, index)"></b-form-select>
                <div v-if="verrors.firstByRule('newLicense_unittype[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Unit Type is required</div>
            </div>
              
            <div class="col-2 col-md-2"  v-if="unitType == 'Seat'">

                <b-form-select class="po_input"  v-bind:id="'newLicense_noofaccounts_' + index" 
                v-bind:name="'newLicense_noofaccounts[' + index + ']'"
                      v-model="newLicense.unit" :options="seat_qty_options" placeholder="Qty" v-validate="'required'"   @change="updateSubTotal(newLicense.subscriptionId, index)" style="width: 65px;">           
                </b-form-select>

                <div v-if="verrors.firstByRule('newLicense_noofaccounts[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Units is required</div>
                
            </div>
               
            <div class="col-2 col-md-2" v-else>
                <input type="text" class="po_input"  v-bind:id="'newLicense_noofaccounts_' + index" 
                v-bind:name="'newLicense_noofaccounts[' + index + ']'"
                      v-model="newLicense.unit" style="width: 50px;" v-on:blur="updateSubTotal(newLicense.subscriptionId, index)" v-validate="'required|numeric'">
                <div v-if="verrors.firstByRule('newLicense_noofaccounts[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg"># of Accounts is required</div>
                <div v-if="verrors.firstByRule('newLicense_noofaccounts[' + index + ']', 'numeric')" class="margin-bottom-5 validate-warning-msg"># of Accounts should be numeric</div>
                
            </div>
              
              <div class="col-2 col-md-2 text-center"  v-bind:name="'newLicense_price[' + index + ']'" v-bind:id="'newLicense_price_' + index" >
               
              </div>
                
              
              <div class="col-2 col-md-2">
                <span class="dollarsign">$</span>&nbsp;<input type="text" class="po_input" v-bind:name="'newLicense_overrideprice[' + index + ']'"
                    v-bind:id="'newLicense_overrideprice_' + index" v-on:blur="overridePriceSubTotal(index)"
                    v-model="newLicense.overrideSubscriptionPrice" >
                   
                <div v-if="isNumericOnlyErrorMsg" class="margin-bottom-5 validate-warning-msg">Override price should be numeric</div>                
            </div>
                
              
              <div class="col-2 col-md-2 text-center" v-bind:name="'newLicense_subtotal[' + index + ']'"
                    v-bind:id="'newLicense_subtotal_' + index"  ></div>
                    
              
              <div class="col-1 col-md-1 text-right">  &nbsp;            
            <!--i class="fa fa-plus spacer-icon" style="text-align: right; color: #00ACEE;" aria-hidden="true" v-on:click="addNewLicense()" v-if = "index == 0"></i>
            <i class="fa fa-remove spacer-icon"  aria-hidden="true" style="color: #FF0000;" v-on:click="removeNewLicense(index)"  v-if = "index > 0"></i-->
            </div>
           
           </div>
          </div>
          
            </div>
          </form>  
    </div>

    
           
    <div style="clear: both;"></div>


<div class="row pay_detail_row mt-3">
    <div class="col-md-6" id="pay_detail_row">
        <div class="card card_info">
            <div class="card-header purchasing_header">
                <div class="card-title purchase_title">Secure Payment</div>
            </div>
            <div class="card-body purchasing_body" id="billing_form_cc">
                <form id="card_form" class="mt-2" autocomplete="off">
                    <div class="row">
                        <div class="col-sm-12 col-md-12">
                            <div class="radio">
                                <label class="radio_input">
                                    <input type="radio"  value="credit_card" v-validate="'required'" v-model="paymentMethod" name="payment_method" v-on:click="choosePaymentMode">&nbsp;Credit Cards (Process Online)
                                </label>
                                <div v-if="verrors.firstByRule('payment_method', 'required')" class="margin-bottom-5 validate-warning-msg">You must choose a payment method</div>
                                <div id="card_info" class="payment_mode_opt" style="display: block;">
                                    <div class="form-group row">
                                        <label for="card_no" class="col-sm-3 col-md-3 col-form-label">Name on Card:</label>
                                        <div class="col-sm-9  col-md-9">
                                            <input type="text" class="form-control billingInput" name="name_on_card" v-model="nameOnCard" v-validate=" isCCRequired ? 'required' : '' "  :disabled="isCreditPanel">
                                            <div v-if="verrors.firstByRule('name_on_card', 'required')" class="margin-bottom-5 validate-warning-msg">Name on Card is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="card_no" class="col-sm-3 col-md-3 col-form-label">Card Number:</label>
                                        <div class="col-sm-9  col-md-9">
                                            <input type="text" class="form-control billingInput" name="card_no" v-model="cardNumber" v-validate=" isCCRequired ? 'required' : '' " :disabled="isCreditPanel">
                                            <div v-if="verrors.firstByRule('card_no', 'required')" class="margin-bottom-5 validate-warning-msg">Card Number is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="exp_month" class="col-form-label col-md-3">Expiration Date:</label>
                                       
                                            <select class="custom-select card_exp" name="exp_month" style="margin-left: 15px; width:70px; " v-model="expMonth" v-validate=" isCCRequired ? 'required' : '' " :disabled="isCreditPanel">
                                                <option value="">MM</option>
                                                <option value="01">01</option>
                                                <option value="02">02</option>
                                                <option value="03">03</option>
                                                <option value="04">04</option>
                                                <option value="05">05</option>
                                                <option value="06">06</option>
                                                <option value="07">07</option>
                                                <option value="08">08</option>
                                                <option value="09">09</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                            </select>
                                            <span style="margin-top: 10px;">&nbsp;&nbsp;/&nbsp;&nbsp;</span>

                                            <b-form-select
                          class="custom-select card_exp"
                          name="exp_year" v-model="expYear" v-validate=" isCCRequired ? 'required' : '' " style="width:70px; "
                          :options="year_options" :disabled="isCreditPanel">
                          </b-form-select>
                                       
                                           <span> <label for="cvv" class="col-form-label col-md-1">CVV:</label></span>
                                            
                                           <input type="password" class="form-control billingInput col-md-2" name="cvv" v-model="cvvValue" v-validate=" isCCRequired ? 'required' : '' " :disabled="isCreditPanel"
                                           role="presentation"
                                           autoComplete="new-password"
                                           >
                                            

                                            <img src="@/assets/CVV.png"  width="25" height="30" alt="CVV image" class="center" style="margin-top: 2px;">

                                           
                                       
                                    </div>
                                    <div class="form-group row">
                                        
                                        <div class="col-sm-1 col-1 p-0" id="card_img">
                                            
                                        </div>
                                    </div>
                                    <div>
                                     <span v-if="verrors.firstByRule('exp_month', 'required')" class="margin-bottom-5 validate-warning-msg" style="margin-left:120px;">Month is required</span>

                                     <span v-if="verrors.firstByRule('exp_year', 'required')" class="margin-bottom-5 validate-warning-msg" style="margin-left:10px;">Year is required</span>                                     

                                      <span v-if="verrors.firstByRule('cvv', 'required')" class="margin-bottom-5 validate-warning-msg" style="margin-left:10px;">CVV is required</span>
                                    </div>   
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="radio">
                                <label class="radio_input"><input type="radio" name="payment_method" v-on:click="choosePaymentMode" value="check" v-model="paymentMethod">&nbsp;Check (Mail In)</label>
                                <div id="check_info" class="payment_mode_opt" style="display: block;">
                                    <div class="form-group row">
                                        <label for="is_check_received" class="col-sm-3 col-form-label">Check Received:</label>
                                        <div class="col-sm-9 pt-2">
                                            <input type="checkbox" id="is_check_received" ref="check_received_flag" value="1" v-model="checkReceived" @click="chooseCheckReceived($event)" :disabled="isCheckPanel">
                                            <div v-if="isCheckReceivedValidateMsg" class="margin-bottom-5 validate-warning-msg">Check Received is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="check_no" class="col-sm-3 col-form-label">Check Number:</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control billingInput" id="check_no" v-model="checkNumber" name="check_number" v-on:blur="validateCheckNumber($event)" :disabled="isCheckPanel">
                                            <div v-if="isCheckNumberValidateMsg" class="margin-bottom-5 validate-warning-msg">Check Number is required</div>
                                            <div v-if="isCheckNumberNumericMsg" class="margin-bottom-5 validate-warning-msg">Check Number be numeric</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="row">
                        <div class="col-sm-12 col-md-12">
                            <div class="radio">
                                <label class="radio_input">
                                    <input type="radio"  value="invoice_po" v-validate="'required'" v-model="paymentMethod" name="payment_method" v-on:click="choosePaymentMode">&nbsp;Invoice for Purchase Order
                                </label>
                          </div>
                        </div>
                    </div>  -->     
                  
                </form>

            </div>
        </div>
        <div class="row justify-content-center">
    <button class="btn btn-primary customBtn mt-3" @click="processPayment()">Process Payment</button>
</div>
    </div>
    <div class="col-md-6" id="pay_detail_row">
        <div class="card billing_info">
            <div class="card-header purchasing_header">
                <div class="card-title purchase_title">Billing Information</div>
            </div>
            <div class="card-body purchasing_body">
                <form id="billing_form" class="mt-2" autocomplete="off">
                    <div class="form-group row">
                       
                            <input type="text" class="form-control billingInput" id="billing_admin" v-model="billingName" name="billing_name" v-validate="{ rules: { required: true} }" placeholder="Billing Name">
                            <div v-if="verrors.firstByRule('billing_name', 'required')" class="margin-bottom-5 validate-warning-msg">Billing Name is required</div>
                    </div>
                    
                    <div class="form-group row">
                        <b-form-select
                          class="custom-select billingInput"
                          id="country_id" v-model="billingCountry" v-validate="'required'" name="billing_country"
                          :options="country_options"
                          v-on:change="getStateLists(billingCountry)">
                          </b-form-select>
                            
                            <div v-if="verrors.firstByRule('billing_country', 'required')" class="margin-bottom-5 validate-warning-msg">Country is required</div>
                       
                    </div>
                    <div class="form-group row">
                        
                            <input type="text" class="form-control billingInput" name="billing_address_1" placeholder="Billing Address 1" v-model="billingAddress" v-validate="'required'" >
                            <div v-if="verrors.firstByRule('billing_address_1', 'required')" class="margin-bottom-5 validate-warning-msg">Billing Address 1 is required</div>
                    </div>
                    <div class="form-group row">
                        
                            <input type="text" class="form-control billingInput" name="billing_address_2" placeholder="Billing Address 2" v-model="billingAddress2" >
                    </div>
                    
                    <div class="form-group row">
                       
                            <input type="text" class="form-control billingInput" name="billing_city" placeholder="City" v-model="billingCity" v-validate="'required'">
                             <div v-if="verrors.firstByRule('billing_city', 'required')" class="margin-bottom-5 validate-warning-msg">City is required</div>
                        
                    </div>
                    <div class="form-group row">
                             <b-form-select
                          class="custom-select billingInput"
                          name="billing_state" v-model="billingState" v-validate="'required'"
                          :options="state_options">
                          </b-form-select>

                            
                            <div v-if="verrors.firstByRule('billing_state', 'required')" class="margin-bottom-5 validate-warning-msg">State is required</div>
                        
                    </div>
                    <div class="form-group row">

                            <input 
                            type="text" 
                            name="zip code" 
                            id="org_zip"
                            ref="org_zip"
                            v-validate="{ rules: { regex: getPostalCodeRegex(), required: true } }"
                            v-model="billingZip"
                            maxlength="10"
                            class="form-control billingInput" 
                            placeholder="Zip">
                            <div v-show="verrors.has('zip code')" class="validate-warning-msg">{{ verrors.first('zip code') }}</div>

                    </div>
                    <div class="form-group row">
                        <input 
                        type="text" 
                        name="phone number" 
                        id="phone_number"
                        ref="phone_number"
                        v-validate="{ rules: { regex: phoneRegex(), required: true } }"
                        v-model="billingPhone"
                        @keyup="billingPhoneValid"
                        @blur="billingPhoneValid"
                        class="form-control billingInput" 
                        placeholder="Phone Number">
                        <div v-show="verrors.has('phone number')" class="validate-warning-msg">{{ verrors.first('phone number') }}</div>                           
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<enterprisePurchaseModal 
          :isModalVisible="isPurchaseModalVisible" 
          :status="orderStatus" 
          :orderId="orderId"
          @close="isPurchaseModalVisible = false"
          ref="admin_purchase_form">
</enterprisePurchaseModal>
 </div>
 <!-- end purchase block -->

 <!-- Apply license block -->
  <div v-if="mode == 'applyLicense'">
  <div class="col-12 override-padding">
          <div class="crm_admin_heading col-12 text-align-center">Select Accounts to Activate</div>        
        </div>
        <div style="clear: both;"></div>
        <div class="unit-wrapper row"> 
          <div class="col-10">
            <div >
              Licenses Available: {{ licenseAvailable }}
             </div>
           </div>
            <div class="col-2">
            <div class="bottom-align">  
             Licenses Used: {{ licenseApplied }}
            </div>
           </div>    
          </div>
          <div class="newlicense-wrapper">
            &nbsp;
            <button v-on:click="newPurchase()"
            class="btn btn-red btn-group-sm input-height-15"
            ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Add License</button>
          </div>  
         
          <div style="clear: both;"></div>
           
        <div class="col-12 override-padding mt-2">
           <div class="crm_admin_heading account_heading_1 text-left"><input type="checkbox" id="selectAll"  @change="checkAccount" v-model="allSelected" value="1"/></div>
          <div class="crm_admin_heading account_heading_2 text-left">Account Name</div>
          <div class="crm_admin_heading account_heading_4 text-left">City</div>
          <div class="crm_admin_heading account_heading_5 text-center">State</div>
          <div class="crm_admin_heading account_heading_6 text-center">Postal Code</div>
          <div class="crm_admin_heading account_heading_8 text-center">Licenses to be assigned</div>
          <div class="crm_admin_heading account_heading_3 text-center">Available Licenses</div>
          <div class="crm_admin_heading account_heading_9 text-center">Used Licenses</div>
          <div class="crm_admin_heading account_heading_10 text-center">Status</div>
        </div>
        
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div style="clear: both;"></div>
        <div class="accounts_items unit-wrapper" v-if="enterprise_accounts.length > 0">
          <div v-for="(account, index) in enterprise_accounts">
             <div class="crm_admin_field_lists account_heading_1 text-left"><input :value="account.accountId" 
                  :id="account.accountId" 
                  type="checkbox" 
                  :checked="account.checked"
                  @change="checkboxclicked(index, account.accountId)"  
                   /></div>
            <div class="crm_admin_field_lists account_heading_2 text-left">
                  {{ account.accountName }}
              </div>
              <div class="crm_admin_field_lists account_heading_4 text-left">
                  {{ account.city }}
              </div>
              <div class="crm_admin_field_lists account_heading_5 text-center">
                {{ account.state }}
              </div>
              <div class="crm_admin_field_lists account_heading_6 text-center">
                {{ account.zip }}
              </div>
              <div class="crm_admin_field_lists account_heading_8 text-center">
                <input type="text" class="po_input" v-bind:name="'qty[' + index + ']'"
                    v-bind:id="'qty_' + index" v-on:blur="qtyCalculation(index, account.accountId)"
                    v-model="account.qty"
                    placeholder="0"
                    :disabled="account.disabled" >
              </div>
              <div class="crm_admin_field_lists account_heading_3 text-center">
                {{ account.activeLicense }}
              </div>
              <div class="crm_admin_field_lists account_heading_9 text-center">
                {{ account.usedLicense }}
              </div>
              <div :class="'crm_admin_field_lists account_heading_10 text-center font-weight-bold ' + getStatusColor(account.status)">
                {{ account.status }}
              </div>

            <div style="clear: both;"></div>
          </div>
        </div>

        <div class="col-12 override-padding" v-if="enterprise_accounts.length == 0">
          No Accounts found
        </div>
        
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div class="apply-button-wrapper">
        <button class="btn btn-primary customBtn mt-3" @click="getApplyAccountLicense" v-if="enterprise_accounts.length > 0">Apply License</button>
        </div> 
  </div>
  <!-- End Apply license block -->

  <!-- Send Invoice block -->
  <div v-if="mode == 'sendInvoice'">
  <div class="scraping_header"></div>
  <div class="success-msg-wrapper">
      <div class="invoice-row" style="color: #00ACEE; text-align: center;">
         Your transaction has been successfully processed.  
       </div>
       <div class="invoice-row">
         Please input the email address that you would like your receipt for purchase sent to.   
       </div>
  </div>     
  <div class="invoice-wrapper">  
  <div class="col-12 override-padding">       
       <div class="invoice-row" style="display: flex;">
          <label class="invoice-label">Email:</label>
          <input type="text" name="toemail" class="invoice-input" v-model="toemail" v-validate="'required|email'">
          <span>&nbsp;</span>
       </div>
       <div v-if="verrors.firstByRule('toemail', 'required')" class="margin-bottom-5 validate-warning-msg">Email is required</div>
       <div v-if="verrors.firstByRule('toemail', 'email')" class="margin-bottom-5 validate-warning-msg">Enter a valid Email</div>

       <div class="invoice-row" v-for="(additionalEmail, aindex) in additionalEmails" :key="aindex" style="display: flex;">
          <label class="invoice-label">Send a copy to:</label>
          <input type="text" v-bind:id="'additionalEmail_copyto_' + index" 
                v-bind:name="'additionalEmail_copyto[' + index + ']'"
                v-model="additionalEmail.copyto" class="invoice-input">
          <span> <i class="fa fa-remove spacer-icon"  aria-hidden="true" style="color: #FF0000;" v-on:click="removeAdditionalEmail(aindex)"  v-if = "aindex > 0"></i> </span>
             
       </div>
       <div class="invoice-row additional-email" @click="addAdditionalEmail">
         Add additional Email  
       </div>
       <div class="invoice-row" >
                      <vue-editor v-model="emailMessage" :editorToolbar="customToolbar" placeholder="Enter Text..."></vue-editor>
        </div>
       <div style="clear: both;" class="margin-bottom-10"></div> 
       <div class="invoice-row button-wrapper">
          <button class="btn btn-primary customBtn mt-3" @click="sendInvoiceEmail()">Submit</button>
       </div>       
  </div>
  </div>
  </div>
  <!-- End Send Invoice block -->

 </div>
 </div>
</template>

<script>
import axios from 'axios';
import enterprisePurchaseModal from './enterprise_purchase_confirm.vue';
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import applyLicenseTab from './enterprise_apply_licenses.vue';
import { VueEditor } from "vue2-editor";

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
 props: ['accountId'],
 data() {
 return {
     subscriptionLevels: [],
     subscriptionId: '',
     selectedSubscriptionPrice: '',
     unit: 1,
     licenseType: '',
     minQty: 1,
     subscriptionTotal: '',
     overrideSubscriptionPrice: '',
     billingName: '',
     billingAddress: '',
     billingAddress2: '',
     billingCity: '',
     billingState: '',
     billingCountry: '',
     billingZip: '',
     billingPhone: '',
     paymentMethod: '',
     nameOnCard: '',
     cardNumber: '',
     expMonth: '',
     expYear: '',
     cvvValue: '',
     checkNumber: '',
     checkReceived: false,
     isCCRequired: 0,
     country_options: [],
     state_options: this.state_options = [{ value: '', text: 'Select State' }],
     year_options: [],
     maxMentors: 0,
     isPurchaseModalVisible: false,
     invoiceFilename: '',
     orderId: '',
     orderStatus: '',
     isNumericOnlyErrorMsg: false,
     isMaxMentorNumericOnly: false,
     isCustomPlan: false,
     subscriptionIds: [],
     isCheckReceivedValidateMsg: false,
     isCheckNumberValidateMsg: false,
     isCheckNumberNumericMsg: false,
     isCheckPanel: true,
     isCreditPanel: false,
     enterprise_new_licenses: [],
     mode:'',
     enterprise_accounts: [],
     unitType: [],
     licenseAvailable: 0,
     licenseSelected: [],
     usedLicense: 0,
     licenseApplied: '',
     customToolbar:[[{ list: "bullet" }, "bold", "italic", "underline"]],
     additionalEmails: [{"copyto": ''}],
     toemail: '',
     emailMessage: '', 
     purchaseOrderId: '',
     allSelected: false,
     appliedAccounts:'',
     sub_loading: false,    
     unitType: '',
     description: '',
 }
 },
 components: {
   enterprisePurchaseModal,
   VueEditor
 }, 
 methods: {
    qtyCalculation: function(index, accountId) {
        this.usedLicense = 0;
        this.usedLicense = parseInt(this.usedLicense + this.enterprise_accounts[index].qty);
        if(this.usedLicense > this.licenseAvailable) {
            this.enterprise_accounts[index].qty = 0;
            document.getElementById(accountId).checked = false;
            alert("Total License Used Exceed than Available License");
            return false;
        }
    },
    checkboxclicked: function(index, accountId) {

        if(document.getElementById(accountId).checked == true) {
            this.enterprise_accounts[index].disabled = false;
            this.enterprise_accounts[index].qty = '';
        }
        else {
            this.enterprise_accounts[index].disabled = true;
            this.enterprise_accounts[index].qty = 0;
        }
    },
    checkAccount() {
           if (this.allSelected) {
                this.enterprise_accounts.forEach((account, index) => { 
                  document.getElementById(account.accountId).checked = true;
                  this.enterprise_accounts[index].disabled = false;
                  this.enterprise_accounts[index].qty = '';
                })
           }
           else {
                this.enterprise_accounts.forEach((account, index) => { 
                  document.getElementById(account.accountId).checked = false;
                  this.enterprise_accounts[index].disabled = true;
                  this.enterprise_accounts[index].qty = 0;

                })
           }
    },
    billingPhoneValid: function(event) {
        var billing_phone = this.billingPhone;
        this.billingPhone = billing_phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    },
    phoneRegex: function() {
        return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    },
    getPostalCodeRegex: function() {
        if (this.billingCountry == "US") {
            return /^[0-9]{5}(?:-[0-9]{4})?$/;
        } else if (this.billingCountry == "CA") {
            return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
        }
        return /./;
    },
   getPriceforSubscription: function(subscriptionSelected, index) {     
     var planName = this.subscriptionIds[subscriptionSelected].toLowerCase();
     this.overrideSubscriptionPrice = '';
     this.isNumericOnlyErrorMsg = false;
     this.licenseType = '';
     this.unit = 1;
     this.minQty = 1;
     this.isMaxMentorNumericOnly = false;
     var eleNoofAccounts = document.getElementById("newLicense_noofaccounts_" + index);
     var noofAccounts = eleNoofAccounts.value;
     axios('/lookups-active-subscriptions/' + this.accountId + '/' + subscriptionSelected,
          {
            method: 'GET',
          }
        )
        .then(resp => {

            this.licenseType = resp.data[0].licenseType;
            this.unitType = resp.data[0].name;
            this.unit = resp.data[0].minQty;
            this.minQty = resp.data[0].minQty;
            this.enterprise_new_licenses[index].unit = this.minQty;

            var ele = document.getElementById("newLicense_price_" + index);
            ele.innerText= '$'+ resp.data[0].price;
            var subscriptionPrice = resp.data[0].price;
            var eleNoofAccounts = document.getElementById("newLicense_noofaccounts_" + index);
            eleNoofAccounts.value = this.minQty;
            var noofAccounts = eleNoofAccounts.value;
            var eleSubscriptionTotal =  document.getElementById("newLicense_subtotal_" + index); 
            var eleOverridePrice = document.getElementById("newLicense_overrideprice_" + index);
            var overrideSubscriptionPrice = eleOverridePrice.value;
            if (overrideSubscriptionPrice == "") {
                if(resp.data[0].name == 'Seat') {
                    eleSubscriptionTotal.innerText = '$'+ (subscriptionPrice);
                }
                else if(this.licenseType == 'Bundle License') {
                    eleSubscriptionTotal.innerText = '$'+ (subscriptionPrice);
                }
                else {
                    eleSubscriptionTotal.innerText = '$'+ (noofAccounts * subscriptionPrice);
                }
            }
            else {
                if(resp.data[0].name == 'Seat') {
                    eleSubscriptionTotal.innerText = '$'+ (overrideSubscriptionPrice);
                }
                else {

                    eleSubscriptionTotal.innerText = '$'+ (noofAccounts * overrideSubscriptionPrice);
                }
            }


          })
        .catch(error => {

        });
   },
   updateSubTotal(subscriptionSelected, index) {
        this.isNumericOnlyErrorMsg = false;
        this.isMaxMentorNumericOnly = false;
        var eleNoofAccounts = document.getElementById("newLicense_noofaccounts_" + index);
        var noofAccounts = eleNoofAccounts.value;
        if(noofAccounts < this.minQty) {
            alert("Quantity should be equal or greater than " + this.minQty);
            eleNoofAccounts.value = this.minQty;
            noofAccounts = eleNoofAccounts.value;
        }

        if((noofAccounts > 0) && (subscriptionSelected > 0)) {
        axios('/getsubscriptionPrice',
          {
            method: 'GET',
            params: {
              subscriptionId: subscriptionSelected,
              qty: noofAccounts,
              accountId: this.accountId,
            }
          }
        )
        .then(response => {

            var ele = document.getElementById("newLicense_price_" + index);
            ele.innerText= '$'+ response.data;
            var subscriptionPrice = response.data;
            var eleNoofAccounts = document.getElementById("newLicense_noofaccounts_" + index);
            var noofAccounts = eleNoofAccounts.value;
            var eleSubscriptionTotal =  document.getElementById("newLicense_subtotal_" + index); 
            var eleOverridePrice = document.getElementById("newLicense_overrideprice_" + index);
            var overrideSubscriptionPrice = eleOverridePrice.value;
            if (overrideSubscriptionPrice == "") {
                if(this.unitType == 'Seat') {
                    eleSubscriptionTotal.innerText = '$'+ (subscriptionPrice);
                }
                else if(this.licenseType == 'Bundle License') {
                    eleSubscriptionTotal.innerText = '$'+ (subscriptionPrice);
                }
                else {
                    eleSubscriptionTotal.innerText = '$'+ (noofAccounts * subscriptionPrice);
                }
                
            }
            else {
              if(this.unitType == 'Seat') {
                eleSubscriptionTotal.innerText = '$'+ ( overrideSubscriptionPrice);
              }
              else {
                eleSubscriptionTotal.innerText = '$'+ (noofAccounts * overrideSubscriptionPrice);
              }
            }


          })
        .catch(error => {

        });
        }

   },
   overridePriceSubTotal(index) {
        var ele = document.getElementById("newLicense_price_" + index);
        var subscriptionPrice = ele.innerText.slice(1);
        var eleOverridePrice = document.getElementById("newLicense_overrideprice_" + index);
        var overrideSubscriptionPrice = eleOverridePrice.value;
        var eleNoofAccounts = document.getElementById("newLicense_noofaccounts_" + index);
        var noofAccounts = eleNoofAccounts.value;
        var eleSubscriptionTotal = document.getElementById("newLicense_subtotal_" + index); 
        if (overrideSubscriptionPrice == "") {
            if(this.unitType == 'Seat') {
                eleSubscriptionTotal.innerText = '$'+ (subscriptionPrice);
            }
            else if(this.licenseType == 'Bundle License') {
                eleSubscriptionTotal.innerText = '$'+ (subscriptionPrice);
            }
            else {
                eleSubscriptionTotal.innerText = '$'+ (noofAccounts * subscriptionPrice);
            }
            
            
        } else {
            this.isNumericOnlyErrorMsg = false;
            const pattern = /^\d*$/;
            if (!pattern.test(overrideSubscriptionPrice)) {
                this.isNumericOnlyErrorMsg = true;
                overrideSubscriptionPrice = "";
                eleSubscriptionTotal.innerText = "";
                if (subscriptionPrice) {
                    eleSubscriptionTotal.innerText = '$'+ (noofAccounts * subscriptionPrice);
                }
            } else {
                if(this.unitType == 'Seat') {
                    eleSubscriptionTotal.innerText = '$'+ (overrideSubscriptionPrice);
                }
                else {
                    eleSubscriptionTotal.innerText = '$'+ (noofAccounts * overrideSubscriptionPrice);
                }   
                
                
            }
        }
   },
   validateMaxMentor() {
        this.isMaxMentorNumericOnly = false;
        const pattern = /^\d*$/;
        if (!pattern.test(this.maxMentors)) {
            this.isMaxMentorNumericOnly = true;
            this.maxMentors = 0;
        }
   },
   processPayment() {
      this.$validator.validateAll().then((result) => {
             if ((this.verrors.items.length === 0) && this.validateCheckReceived()) { 
                this.isPurchaseModalVisible = true;

                axios('/enterprise/orders',
                    {
                    method: 'POST',
                    data:
                        {
                        new_licenses: this.enterprise_new_licenses,
                        account_id: this.accountId,
                        billing_name: this.billingName,
                        billing_address: this.billingAddress,
                        billing_address2: this.billingAddress2,
                        billing_city: this.billingCity,
                        billing_state: this.billingState,
                        billing_country: this.billingCountry,
                        billing_zip: this.billingZip,
                        billing_phone: this.billingPhone,
                        payment_method: this.paymentMethod,
                        name_oncard: this.nameOnCard,
                        card_number: this.cardNumber,
                        exp_month: this.expMonth,
                        exp_year: this.expYear,
                        cvv_value: this.cvvValue,
                        check_number: this.checkNumber,
                        check_received: this.checkReceived,
                        },
                    }
                    )
                    .then((resp) => { 
                       document.getElementById("payment_loader").style.display = 'none';
                       document.getElementById("success_payment").style.display = 'block';
                                               
                        if(resp.data.msg == 'success') {                            
                            this.orderId = resp.data.order_id;
                            this.orderStatus = resp.data.msg;
                        }
                        else {
                            this.orderId = resp.data.order_id;
                            this.orderStatus = resp.data.msg;
                        }
                    })
                    .catch(error => {
                    });  
             }
            })
        .catch(() => {

        });     
   },
   getCountryLists: function () {
          axios.get('/get-country-lists', {

          })
          .then(response =>  {
            this.country_options = response.data;
          })
          .catch(function(error) {

          });
    },
    getStateLists: function (CountryCode, index) {
          this.billingState = "";
          this.state_options = [
            { value: '', text: 'Select State' },
          ];
          if(CountryCode == '') {
            CountryCode = null;
          }
          axios.get('/get-state-lists/' + CountryCode, {

          })
          .then(response =>  {
            this.state_options = response.data;
          })
          .catch(function(error) {

          });
    },
    getExpiryYears() {       
        var d = new Date();
        var start_year = d.getFullYear().toString().substr(-2)
        var end_year =  parseInt(start_year) + 20;
        //alert(end_year)

        this.year_options = [
            { value: '', text: 'YY' },
          ];
        for(var i=start_year;i<=end_year;i++) {
            var yoptions = { value: i, text: i };
            this.year_options.push(yoptions);
        }        
    },
   choosePaymentMode(event) {
    if(event.target.value == 'credit_card') {
        this.isCCRequired = 1;
        this.isCheckNumberValidateMsg = false;
        this.isCheckNumberNumericMsg = false;
        this.isCheckPanel = true;
        this.isCreditPanel = false;
    }
    else if(event.target.value == 'invoice_po') {
        this.isCCRequired = 0;
        this.isCheckNumberValidateMsg = false;
        this.isCheckNumberNumericMsg = false;
        this.isCheckPanel = true;
        this.isCreditPanel = true;
    }
    else {
        this.isCCRequired = 0;
        this.isCheckPanel = false;
        this.isCreditPanel = true;
    }
   },
   chooseCheckReceived(event) {
       if (event.target.checked) {
            this.isCheckReceivedValidateMsg = false;
            if (this.checkNumber == '') {
                this.isCheckNumberValidateMsg = true;
                this.isCheckNumberNumericMsg = false;
            }
       } else {
           this.isCheckNumberValidateMsg = false;
       }
   },
   validateCheckNumber(event) {
        const pattern = /^\d*$/;
        if (this.checkNumber == '') {
            this.isCheckNumberValidateMsg = false;
            this.isCheckReceivedValidateMsg = false;
        } else {
            if (!pattern.test(this.checkNumber)) {
                this.checkNumber = '';
                this.isCheckNumberNumericMsg = true;
                this.isCheckNumberValidateMsg = false;
            } else {
                this.isCheckNumberNumericMsg = false;
                this.isCheckNumberValidateMsg = false;
                if (!this.checkReceived) {
                    this.isCheckReceivedValidateMsg = true;
                }
            }
        }
   },
    validateCheckReceived() {
        var isFormSubmit = false;
        if (!this.checkReceived && this.checkNumber == '') {
            isFormSubmit = true;
        } else {
            if (this.checkReceived && this.checkNumber == '') {
                this.isCheckNumberValidateMsg = true;
                this.isCheckNumberNumericMsg = false;
                isFormSubmit = false;
            } else {
                const pattern = /^\d*$/;
                if (!pattern.test(this.checkNumber)) {
                    this.isCheckNumberNumericMsg = true;
                    this.isCheckNumberValidateMsg = false;
                    isFormSubmit = false;
                } else {
                    if (!this.checkReceived) {
                        isFormSubmit = false;
                    } else {
                        isFormSubmit = true;
                    }
                }
            }
        }
        return isFormSubmit;
    },
    addNewLicense() {
      this.enterprise_new_licenses.push(
            {
              "subscriptionId": '',
              "unit": '1',
              "overrideSubscriptionPrice": '',                           
            }
          )
    },
    removeNewLicense(index) {
      this.enterprise_new_licenses.splice(index, 1);        
    },
    ltrim(str, chr) {
      var rgxtrim = (!chr) ? new RegExp('^\\s+') : new RegExp('^'+chr+'+');
      return str.replace(rgxtrim, '');
    },
    router_redirect: function(accountId) {
      let routeData = this.$router.resolve({name: 'accountlookupdetail', params: {account_id: accountId}});
      window.open(routeData.href, '_blank');
    },
    getStatusColor(status) {
      if (status == "Active") {
          return 'text_green';
      } else if(status == "Inactive") {
          return 'text_red';
      } else {
          return '';
      }
    },
    addAdditionalEmail() {
        this.additionalEmails.push({"copyto": ''})
    },
    removeAdditionalEmail(index) {
      this.additionalEmails.splice(index, 1);        
    },
    sendInvoiceEmail() {
       this.$validator.validateAll().then((result) => {
         if (this.verrors.items.length === 0) { 
           axios('/enterprise_lookup_purchase/send_invoice',
                      {
                      method: 'POST',
                      data: {
                          emailAddress: this.toemail,
                          orderId: this.purchaseOrderId,
                          copyEmails: this.additionalEmails,
                          msg: this.emailMessage,                      
                      }
                      },
            )
            .then(response => {
                this.flash({ message: 'Email sent successfully with Invoice', variant: 'success' });
                this.navigate();
            })
            .catch(error => {

            })
          }
       }) 
    },        
    getApplyAccountLicense() { 
          this.licenseSelected = [];         
          for(var i=0; i < this.enterprise_accounts.length; i++) {
              if(document.getElementById(this.enterprise_accounts[i].accountId).checked)
              {                
                var subscriptionSelected = { 'accountId': this.enterprise_accounts[i].accountId, 'qty': this.enterprise_accounts[i].qty};
                this.licenseSelected.push(subscriptionSelected);
              }
           }
          
          if(this.licenseSelected.length > 0) {
          axios('/enterprise/license_mapping/insert',
                    {
                    method: 'POST',
                    data:
                        {
                        licenses_applied: this.licenseSelected,
                        enterprise_id: this.accountId,
                        previous_licence_applied: this.appliedAccounts,
                        },
                    }
            )
            .then((resp) => {

                 this.enterprise_accounts.forEach((account, index) => { 
                  document.getElementById(account.accountId).checked = false;
                  this.enterprise_accounts[index].disabled = true;
                  this.enterprise_accounts[index].qty = 0;

                })

                axios.get('/enterprise/license-available/' + this.accountId, {
                        })
                        .then(response =>  {
                            this.loading = false;
                            this.licenseApplied = response.data.usedLicense;
                            this.licenseAvailable = response.data.ActiveLicense;
                            
                            if(this.licenseAvailable > 0) {
                                this.mode = 'doPurchase';
                            }
                            else {
                               this.mode = 'doPurchase'; 
                            }                        
                            
                           if(this.mode == 'applyLicense') {

                             axios.get('/enterprise/license-accounts/' + this.accountId, {
                             })
                             
                             .then(response =>  {
                                 this.loading = false;
                                 this.enterprise_accounts = response.data;
                                 for(var j=0; j < this.enterprise_accounts.length; j++) {
                                   if(this.enterprise_accounts[j].checked) {
                                      this.appliedAccounts += this.enterprise_accounts[j].accountId + ',';                                  
                                   }
                                 }
                                 
                               })
                              .catch(function(error) {

                                });                    
                              } 
                        })
                        .catch(function(error) {

                        });  
                   setTimeout(() => {              
                       if(this.purchaseOrderId != '') {
                        this.mode = 'sendInvoice';
                       }
                       else {
                          if(resp.data.successMsg != '') {
                           alert("License applied successfully")
                          }
                       }
                   }, 2000);

               
            })
            .catch(error => {
            });
            }
    },
    navigate(){
        this.$router.push(this.$router.currentRoute.fullPath)
        this.$router.go();
    },
    newPurchase() {
        this.enterprise_new_licenses = [];
        this.billingName = '',
        this.billingAddress = '';
        this.billingAddress2 = '';
        this.billingCity = '';
        this.billingState = '';
        this.billingCountry = '';
        this.billingZip = '';
        this.billingPhone = '';
        this.paymentMethod = '';
        this.nameOnCard = '';
        this.cardNumber = '';
        this.expMonth = '';
        this.expYear = '';
        this.cvvValue = '';
        this.checkNumber = '';
        this.checkReceived = false;

        this.enterprise_new_licenses.push(
            {
              "subscriptionId": '',
              "unit": '1',
              "overrideSubscriptionPrice": '',
            }
        ); 



       this.mode = 'doPurchase';
    }
 },
 created: function () {
     //document.getElementById("purchasing_view").className = 'active';
    this.sub_loading = true;
     this.enterprise_new_licenses.push(
            {
              "subscriptionId": '',
              "unit": '1',
              "overrideSubscriptionPrice": '',
            }
          )

      axios('/active-subscriptions/' + this.accountId + '/Enterprise',
          {
            method: 'GET'
              
          },
        )
        .then(response => {
           var subscriptionone =  { value: '', text: 'Please select' };
           this.subscriptionLevels.push(subscriptionone);
           for(var i=0; i < response.data.subscriptions.length; i++) {
             var subscription = {value: response.data.subscriptions[i].id, text: response.data.subscriptions[i].name};
              this.subscriptionLevels.push(subscription);
              this.subscriptionIds[response.data.subscriptions[i].id] = response.data.subscriptions[i].name;
            }
            this.sub_loading = false;
         })
        .catch(error => {

        });

        this.getCountryLists();
        this.getExpiryYears();

       
        axios.get('/enterprise/license-available/' + this.accountId, {
                    })
                    .then(response =>  {
                        this.loading = false;
                        this.licenseApplied = response.data.usedLicense;
                        this.licenseAvailable = response.data.ActiveLicense;
                        
                        if(this.licenseAvailable > 0) {
                           this.mode = 'doPurchase';
                        }
                        else {
                           this.mode = 'doPurchase'; 
                        }                        
                        
                       if(this.mode == 'applyLicense') {

                         axios.get('/enterprise/license-accounts/' + this.accountId, {
                         })
                         
                         .then(response =>  {
                             this.loading = false;
                             this.enterprise_accounts = response.data;
                             for(var j=0; j < this.enterprise_accounts.length; j++) {
                               if(this.enterprise_accounts[j].checked) {
                                  this.appliedAccounts += this.enterprise_accounts[j].accountId + ',';                                  
                               }
                             }
                             
                           })
                          .catch(function(error) {

                            });                    
                          } 
                    })
                    .catch(function(error) {

                    });                
 }
 }

</script>

<style>
.purchase-heading-bar {
  width:100%;
}
.pay_detail_row {
    padding: 1rem !important;
}

/* CUSTOM CSS FOR CARD */
.card_info, .billing_info {
    
    border: 1px solid #b6b6b6 !important;
    border-top: none !important;
}
.purchasing_body {
    min-height: 100px;
    padding: 15px;
}
.purchasing_header{
    padding: 0px !important;
    border-bottom: 0px !important;
}
.card-title {
    padding: 8px;
    font-weight: bold;
}


/* CUSTOM CSS FOR CARD TITLE AND HEADING */
.purchase_title {
    background-color: #00ACEE !important;
    color: #FFFFFF !important;
}
.purchase .res_heading {
    background-color: #ADBCB7 !important;
}
.shopping_title {
    background-color: #ADBCB7 !important;
}
.shopping .res_heading {
    background-color: #DC2128 !important;
    color: #FFFFFF !important;
}
.res_heading {
    font-weight: bold;
    padding: 8px;
}
.res_content {
    padding: 3px 5px 3px 5px;
    border-bottom: 1px solid #dee2e6;
}


/* CUSTOM CSS FOR BUTTONS AND ICONS */
.customBtn {
    background-color: #00ACEE !important;
    border-color: #00ACEE !important;
    border-radius: 0px;
    font-size: 13px !important;
    line-height: 15px;
    margin-bottom: 20px;
    padding: 5px 35px 5px 35px;
}
#card_img svg {
    width: 1.5rem;
    height: 2rem;
}

/* CUSTOM CSS FOR INPUT */
.po_input{
    width: 70px;
    margin-bottom: 5px;
}
.card_exp {
    display: inline-block;
}
.payment_mode_opt .custom-select {
    font-size: 13px;
    font-weight: normal;
    background-color: #EBEBEB;
}
.billingInput {
    font-size: 12px !important;
}
.radio_input {
    font-weight: bold;
    font-size: 12px;
}
.payment_mode_opt {
    margin: 0px 0px 0px 30px;
}


/* CUSTOM CSS FOR LABLE AND TEXT */
#total_text {
    font-weight: bold;
    text-transform: uppercase;
}
#priceAmt {
    color: #DC2128;
    font-weight: bold;
    margin-left: 40px;
}
.col-form-label {
    font-size: 12px !important;
}
#card_form .col-form-label{
    white-space: nowrap !important;
    text-align: left !important;
}
#billing_form .col-form-label{
    white-space: nowrap !important;
    text-align: right !important;
    font-weight: bold;
    font-size: 12px;
}


/* Large devices (laptops/desktops, 992px and up) 
@media only screen and (min-width: 992px) {
    .card_exp {
        width: 173px !important;
    }
}


@media only screen and (min-width: 1200px) {
    .card_exp {
        width: 173px !important;
    }
}


@media only screen and (min-width: 768px) {
    .card_exp {
        width: 229px !important;
    }
} */

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
    body {
        font-size: 12px;
    }
    .cartBtn {
        font-size: 11px !important;
        padding: 0px 5px !important;
    }
    #sc_grid{
        overflow: auto;
    }
    #pc_grid {
        overflow: auto;
        white-space: nowrap;
    }
    .pay_detail_row {
        padding: 0rem !important;
    }
    .purchasing_header {
        height: 19px;
    }
    .card_exp {
        width: 62px;
    }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
    body {
        font-size: 12px;
    }
    .cartBtn {
        font-size: 11px !important;
        padding: 0px 5px !important;
    }
    #sc_grid{
        overflow: auto;
    }
    #pc_grid {
        overflow: auto;
        white-space: nowrap;
    }
    .pay_detail_row {
        padding: 0rem !important;
    }
    #billing_form .col-form-label {
        text-align: left !important;
    }
    .purchasing_header {
        height: 19px;
    }
    .card_exp {
        width: 190px;
    }
}

@media only screen and (max-width: 601px) {
    .card_exp {
        width: 162px !important;
    }
}
@media only screen and (max-width: 961px) {
    .col-md-6 {
        max-width: 100% !important;
        flex: 0 0 100% !important;
    }
}

#billing_form {
  margin: 0px 15px 0px 15px;    
}
.unit-wrapper {
  border: 1px solid #b6b6b6;
  border-top: none;
}
#billing_form .form-group, #billing_form_cc .form-group {
    margin-bottom: 5px;
}
#pay_detail_row .card-body {
    padding: 15px 15px 3px 15px;
}
.account_heading_1 { width: 3%; }
.account_heading_2 { width: 18%; }
.account_heading_3 { width: 15%; }
.account_heading_4 { width: 10%; }
.account_heading_5 { width: 8%; }
.account_heading_6 { width: 8%; }
.account_heading_7 { width: 13%; }
.account_heading_8 { width: 15%; }
.account_heading_9 { width: 15%; }
.account_heading_10 { width: 8%; }
.unit-wrapper {
    border: 1px solid #b6b6b6;
    border-top: none;
    position: relative;
    margin: 0px !important;
}
.invoice-wrapper {
  margin-top: 20px;
  width: 45%;
  margin-left: auto;
  margin-right: auto;
 }
 .invoice-label {
   width: 25%;
 }
 .invoice-row {
   margin-bottom: 5px;
   width: 100%;    
 }
 .invoice-input {
   width: 70%;
   line-height: 25px;
 }
 .button-wrapper {
   width: 20%;
   margin-left: auto;
   margin-right: auto;
   margin-top: 20px;
 }
 #quill-container {
   background-color: #FFF;
   height: 30% !important;
 }
 .success-msg-wrapper {
   width: 45%;
   margin-left: auto;
   margin-right: auto;
   margin-top: 10px;
 }
 .additional-email {
   color: #00ACEE; 
   text-align: right;
   margin-bottom: 15px;
   padding-right: 15px;
 }
 .bottom-align {
   position: absolute;
   bottom: 0;   
 }
 .newlicense-wrapper {
   float: right;
   margin-top: 10px;
 }
 .text_green {
    color: #4ea959 !important;
}
.text_red {
    color: #ff0000 !important;
}
.apply-button-wrapper {
   width: 25%;
   margin-left: auto;
   margin-right: auto;
 }      
</style>


// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_purchase_tab.vue